﻿import document from 'document';

export const loadModules = modules => {
    modules.forEach((Module, index) => {
        if (!Module || typeof Module !== 'function') {
            console.log('Invalid module format', module, index);
        }

        const module = Module();
        
        if (module.selector) {
            const components = document.querySelectorAll(module.selector);
            if (components) {
                [...components].forEach(component => {
                    //console.log('initializing module', module.selector);
                    module.init(component);
                });
            } else {
                //console.log('module not found', module.selector);
            }
        } else {
            module.init();
        }
    });
};